module.exports = __webpack_public_path__ + "assets/img/logo.e44684b3.png";